import { DateRange, PickersShortcutsItem } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import i18next from 'i18next';

export const shortcutsItemsGraph = (t: typeof i18next.t): PickersShortcutsItem<DateRange<Dayjs>>[] => [
  {
    label: t('lastSixMonths'),
    getValue: () => {
      const today = dayjs();
      const prev6Months = today.subtract(6, 'month');
      return [prev6Months.startOf('month'), today];
    },
  },
  {
    label: t('lastWeek'),
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(1, 'week');
      return [prevWeek.startOf('week'), prevWeek.endOf('week')];
    },
  },
  {
    label: t('thisYear'),
    getValue: () => {
      const today = dayjs();
      const startOfYear = today.startOf('year');
      return [startOfYear, today];
    },
  },
  {
    label: t('thisWeek'),
    getValue: () => {
      const today = dayjs();
      const startOfWeek = today.startOf('week');
      return [startOfWeek, today];
    },
  },
  {
    label: t('last2Weeks'),
    getValue: () => {
      const end = dayjs().endOf('day').subtract(1, 'day');
      const start = end.clone().subtract(13, 'day');
      return [start, end];
    },
  },
  {
    label: t('lastYear'),
    getValue: () => {
      const today = dayjs();
      const startOfLastYear = today.subtract(1, 'year').startOf('year');
      const endOfLastYear = today.subtract(1, 'year').endOf('year');
      return [startOfLastYear, endOfLastYear];
    },
  },
  {
    label: t('allTime'),
    getValue: () => [null, null],
  },
];
